export const getSlackUserQuery = (id: string) => `{
    getSlackUser(id: "${id}") {
      id
      name
      profilePictureUrl
    }
  }`;
